<!--
Note:
► This page is not particulary part of the project
► This page was made so its easier to navigate between the 2 processes
-->
<template>
    <div class="insurance-process-step">
        <h1 text-center>Welcome to FDCA Insurance Project</h1>
        <p text-center>Please select a section you are working on.</p>

        <div class="role-selector">
            <div class="grid-list-xl text-xs-center">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="selector-item" @click="ToService()">
                            <p class="icon"><IconBase><IconEducator /></IconBase></p>
                            <p class="label">Service<p>
                            <p class="short-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, impedit eveniet voluptatibus ullam non illum quaerat rerum optio ut.</p>    
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="selector-item" @click="ToEducator()">
                            <p class="icon"><IconBase><IconDualEducator /></IconBase></p>
                            <p class="label">Educator<p>
                            <p class="short-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, impedit eveniet voluptatibus ullam non illum quaerat rerum optio ut.</p>    
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </div>
    </div>
</template>

<script>
import IconEducator from '@/components/icons/educator.vue'
import IconDualEducator from '@/components/icons/dualEducator.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import '@/assets/styles/landing-main.scss'

export default {
    name: "Main",
    components: {
        IconBase,
        IconEducator,
        IconDualEducator,
        IconArrowBack
    },
    methods: {
        ToEducator() {
            this.$router.push({name:'Welcome'})
        },
        ToService() {
            this.$router.push({name:'ServiceWelcome'})
        },
        proceed (params){
            window.location='/'+params;
        }
    }
}
</script>
